import type { Sort } from '../../sharedTypes';
import { SORT, type SortAction } from '../actions/sortActions';

export type SortState = {
  selectedSort: Sort | null;
  productRecAbKey: string | null;
};

export const sortInitialState = {
  selectedSort: null,
  productRecAbKey: '',
};

export function sortReducer(state: SortState = sortInitialState, action: SortAction): SortState {
  switch (action.type) {
    case SORT.SET_SELECTED_SORT: {
      return {
        ...state,
        selectedSort: action.sort,
      };
    }
    case SORT.SET_PRODUCT_REC_AB_KEY: {
      return {
        ...state,
        productRecAbKey: action.productRecAbKey,
      };
    }
    default: {
      return state;
    }
  }
}
